import { CheckCircleFilled_str, CheckCircleOutlined_str } from '@zenlayer/zen-design-icons';
import { useUpdateEffect } from 'ahooks';
import classnames from 'classnames';
import * as React from 'react';
import { pickDomAttrs } from '../_util/utils';
import SvgIcon from '../svg-icon';
import './style/index';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
const Steps = props => {
  const {
    steps,
    currentStep = 0,
    onChange,
    block,
    scrollIntoView = false,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-steps");
  const ref = React.useRef(null);
  useUpdateEffect(() => {
    if (scrollIntoView) {
      var _ref$current;
      (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center'
      });
    }
  }, [currentStep]);
  if (!(steps !== null && steps !== void 0 && steps.length)) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }
  return /*#__PURE__*/_jsx("div", {
    ...restProps,
    ref: ref,
    className: classnames(baseClassName, className, {
      block
    }),
    style: style,
    children: steps.map((item, idx) => {
      const {
        renderIcon,
        name,
        disabled
      } = item;
      const active = currentStep === idx;
      const defaultIcon = active ? /*#__PURE__*/_jsx(SvgIcon, {
        svgStr: CheckCircleFilled_str
      }) : /*#__PURE__*/_jsx(SvgIcon, {
        svgStr: CheckCircleOutlined_str
      });
      const domAttrs = pickDomAttrs(item);
      return /*#__PURE__*/_createElement("div", {
        ...domAttrs.data,
        key: idx,
        className: classnames("".concat(baseClassName, "-item"), {
          ["".concat(baseClassName, "-item--current")]: active,
          ["".concat(baseClassName, "-item--active")]: currentStep > idx,
          ["".concat(baseClassName, "-item--disabled")]: !!disabled
        }),
        onClick: () => {
          !disabled && (onChange === null || onChange === void 0 ? void 0 : onChange(idx, item));
        },
        style: {
          cursor: disabled ? 'not-allowed' : onChange ? 'pointer' : 'default'
        }
      }, renderIcon ? renderIcon(active) : defaultIcon, /*#__PURE__*/_jsx("span", {
        children: name
      }));
    })
  });
};
export default Steps;